import { getCurrentlyLoggedInOrImpersonatingUser } from '../services/auth';
import { Roles } from '../models/roles';

export const getUserFullName = user => {
  if (!user) {
    return '';
  }

  return user.lastname
    ? `${(user.firstname || '').trim()} ${(user.lastname || '').trim()}`
    : (user.firstname || '').trim();
};

export const getUserFullNameWithEmail = user => {
  if (!user) {
    return '';
  }

  let userFullNameWithEmail = user.firstname;

  if (user.lastname) {
    userFullNameWithEmail += ` ${user.lastname}`;
  }

  userFullNameWithEmail += ` (${user.email})`;

  return userFullNameWithEmail;
};

export const getCurrentlyLoggedUserFullname = () => {
  const user = getCurrentlyLoggedInOrImpersonatingUser();

  return getUserFullName(user);
};

export const isUserPhoneNumberVerified = user => {
  if (!user) {
    return false;
  }

  return user.hasOwnProperty('phone_verified') && user.phone_verified !== null;
};

export const isUserEmailVerified = user => {
  if (!user) {
    return false;
  }

  return user.hasOwnProperty('email_verified') && user.email_verified !== null;
};

export const isUserActive = user => !!user.active;

export const isUserAbleToClaimRescue = user => isUserActive(user) && isUserEmailVerified(user);

// a rescuer can be paused at some of their sites only, the pause is carried by each site's Rescuer role assignment
export const getRescuerSitePausedAt = (user, siteId) => {
  const rescuerRoleAssignment = (user?.role_assignments || []).find(
    roleAssignment => roleAssignment.role_name === Roles.Rescuer && roleAssignment.site_id === siteId
  );

  return rescuerRoleAssignment?.paused_at || null;
};

// paused_at on the user is the pause the rescuer made themselves, which pauses them at all of their sites
export const isRescuerPausedAtAnySite = user => !!user?.paused_at || (user?.role_assignments || []).some(
  roleAssignment => roleAssignment.role_name === Roles.Rescuer && !!roleAssignment.paused_at
);

export const getUserImage = (user, idTokenPayload, skipFallback = false) => {
  // Uploaded image from S3
  if (user?.profile_picture_url) {
    return user.profile_picture_url;
  }

  // Google avatars
  if (idTokenPayload && idTokenPayload.picture && idTokenPayload.picture.includes('googleusercontent')) {
    return idTokenPayload.picture;
  }

  return skipFallback ? null : 'no-picture'; // Src needs to be a broken link (or in this case a string) for the fallback letter to work - https://github.com/mui/material-ui/issues/32162
};
